import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { AnchorNavigation } from '$partials/ui';
import { Footer, Header, Meta } from '$partials/global';
import { findModuleAnchors, getAllModules } from '$utilities/data';
import ModuleDispatcher from '$partials/modules/dispatcher';
import { useLocale } from '$contexts/locale';
import { useAnchor } from '$contexts/anchor';
import ModuleRelatedCarousel from '$partials/modules/individual/related-carousel';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const FaqPage = ({ data, domain }) => {
    const { translate: t } = useLocale();
    const { setAnchors, anchors } = useAnchor();

    const [isOpen, setIsOpen] = useState(false);

    const page = data?.page;
    let anchorModules = [];
    const modules = getAllModules(page);

    useEffect(() => {
        if (modules) {
            anchorModules = anchorModules.concat(findModuleAnchors(modules));
            setAnchors(anchorModules);
        }
    }, []);

    if (!page) {return null;}

    return (
        <>
            <Meta page={page} />

            <main id='main-content'>
                <div className='min-h-screen'>

                    <Header
                        bgStyle='white'
                        isOpen={isOpen}
                        menu={data?.navigation}
                        setIsOpen={setIsOpen}/>

                    <div className='layout-container z-10 relative'>

                        {/* Header */}
                        <div className='mt-60 md:mt-80'>
                            <div className='px-10 sm:px-20'>
                                <h1 className='type-style-2'>{page?.title}</h1>
                            </div>
                        </div>
                    </div>

                    {/* Content */}
                    {(modules?.length > 0) && (
                        <div>

                            {anchors.length > 0 && (
                                <AnchorNavigation
                                    anchors={anchors}
                                    className='px-20 py-10'/>
                            )}
                            <section className='mt-40 sm:mt-50 md:mt-60'>
                                {modules?.map((module, i) => {
                                    if (!module) {return null;}
                                    return (
                                        <ModuleDispatcher
                                            key={i}
                                            module={module}
                                            nextTypename={modules[i + 1]?.__typename}
                                            parent='FAQ'
                                            previousTypename={modules[i - 1]?.__typename} />
                                    );
                                })}
                            </section>
                        </div>
                    )}
                    {/* Related */}
                    {data.relatedArticles?.items?.length > 0 && (
                        <ModuleRelatedCarousel
                            ctaLabel={t('View All')}
                            ctaLink='/resources'
                            items={data.relatedArticles?.items}
                            title={'Related Resources'}/>
                    )}

                    <div className='layout-container'>
                        <div className='md:pt-60'>
                            <Footer
                                domain={domain}
                                menu={data?.footer} />
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    data: PropTypes.shape({
        footer: PropTypes.shape({
            items: PropTypes.array
        }),
        page: PropTypes.object,
        relatedArticles: PropTypes.object,
        navigation: PropTypes.object
    }),
    domain: PropTypes.string,
};

FaqPage.propTypes = propTypes;

export default FaqPage;
